import { render } from "./ProductFunction.vue?vue&type=template&id=b5a53c06&scoped=true"
import script from "./ProductFunction.vue?vue&type=script&lang=js"
export * from "./ProductFunction.vue?vue&type=script&lang=js"

import "./ProductFunction.vue?vue&type=style&index=0&id=b5a53c06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a53c06"]])

export default __exports__